import React from 'react';
import '../style/warning.css';
import config from '../config/config.js';
import {i18n_get_value, I18N_LABELS} from '../i18n/i18n_scripts';

export default class Unauthorised extends React.Component {
    render() {
        console.debug("Config: " + Object.keys(config));
        return (<div className="page-wrap">
            <div className="container">
                <div className="message animated bounceIn">
                    <div className="display-table">
                        <div className="display-table-cell">
                            <svg className="icon icon-left icon-x"></svg>
                        </div>
                        <div className="display-table-cell">
                            <h1>{i18n_get_value(I18N_LABELS.UNAUTHORISED_TITLE)}</h1>
                            <p>{i18n_get_value(I18N_LABELS.UNAUTHORISED_GO_BACK)} <a href={ config.homeUrl }>{i18n_get_value(I18N_LABELS.UNAUTHORISED_PAGE_NAME_LINK)}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}
